// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IDeleteOfferFromFavoritesRequest,
  TDeleteOfferFromFavoritesModel,
  IMappers,
  TDeleteOfferFromFavoritesResponse,
  IDeleteOfferFromFavoritesResponse,
  IDeleteOfferFromFavoritesResponseError,
} from './types';

export const defaultConfig: TDeleteOfferFromFavoritesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/delete-offer-from-favorites/',
  requestType: 'json',
  responseType: 'json',
} as TDeleteOfferFromFavoritesModel;

export function createDeleteOfferFromFavoritesModel(
  parameters: IDeleteOfferFromFavoritesRequest,
): TDeleteOfferFromFavoritesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDeleteOfferFromFavoritesRequest;
}

export async function fetchDeleteOfferFromFavorites<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400>): Promise<
  TDeleteOfferFromFavoritesResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createDeleteOfferFromFavoritesModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteOfferFromFavoritesResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IDeleteOfferFromFavoritesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDeleteOfferFromFavoritesResponse;
}
